import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { ApiUsuarioService } from '../services/api-usuario.service';


@Injectable({
  providedIn: 'root'
})
export class ActionGuard  {

	constructor(private apiUsuario: ApiUsuarioService, private router: Router, private activatedRoute: ActivatedRoute){}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.verificaStatus();
  }

  private verificaStatus() {
    let result : any = this.apiUsuario.verificaLicenca();

    if (result?.prazoHoras < 0 || (result.status == 2 || result.status == 3) && !result.periodoTeste && this.activatedRoute) {
      this.router.navigate(['/meu-plano']);
      return false;
    }
    
    return true;
	}
  
}
